import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatModule, StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  InputModule,
  RadiobuttonModule,
  CheckboxModule,
  ButtonModule,
  SelectModule,
  SelectDateYmdModule,
  TextTooltipModule,
} from '@lib/components';
import { PassengerInformationComponent } from './passenger-information.component';
import { ArrivalDepartureNoticeInformationComponent } from './additional-information/arrival-departure-notice-information/arrival-departure-notice-information.component';
import { ImmigrationInformationComponent } from './additional-information/immigration-information/immigration-information.component';
import { PassportInformationComponent } from './additional-information/passport-information/passport-information.component';
import { SupportInformationComponent } from './additional-information/support-information/support-information.component';
import { PassengerInformationService } from '@common/services/my-booking/passenger-information-input-modal/passenger-information.service';
import { PassportInformationService } from '@common/services/my-booking/passenger-information-input-modal/passport-information.service';

@NgModule({
  declarations: [
    PassengerInformationComponent,
    ArrivalDepartureNoticeInformationComponent,
    ImmigrationInformationComponent,
    PassportInformationComponent,
    SupportInformationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
    RadiobuttonModule,
    CheckboxModule,
    ButtonModule,
    SelectModule,
    SelectDateYmdModule,
    StaticMsgModule,
    TextTooltipModule,
    DateFormatModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [PassengerInformationComponent],
  providers: [StaticMsgPipe, PassengerInformationService, PassportInformationService],
})
export class PassengerInformationModule {}
